import qs from 'qs'

export const isProd = ENV_IS_PRODUCTION || false

export const getTestingEnv = () => {
    const { testing: isTestingEnvironment } = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    })
    const geoAppTestingFromLocalStorage = localStorage.getItem('geoAppTesting')

    if (isTestingEnvironment && !geoAppTestingFromLocalStorage) {
        localStorage.setItem('geoAppTesting', true)
    }

    return !!isTestingEnvironment || geoAppTestingFromLocalStorage
}

export const getMaxTextureSize = () => {
    const { maxTextureSize } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return parseInt(maxTextureSize, 10) || null
}

export const getMemoryTrackingEnv = () => {
    const { memoryTrackingEnv } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return memoryTrackingEnv
}

export default ENV_MODE
